import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/3dd345f1161c0117e4cc98032d537979/9e9b5041da0d1342cba62df04a945317.png" 
              alt="Logo" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              기독교 커뮤니티를 위한<br />
              MUST 플랫폼
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">서비스</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/content" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  콘텐츠
                </Link>
              </li>
              <li>
                <Link to="/commerce" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  MUST몰
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  커뮤니티
                </Link>
              </li>
              <li>
                <Link to="/talent" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  달란트 소개
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">파트너</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/merchant" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  가맹점
                </Link>
              </li>
              <li>
                <Link to="/supplier" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  공급사
                </Link>
              </li>
              <li>
                <Link to="/content-supplier" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  콘텐츠 공급사
                </Link>
              </li>
              <li>
                <Link to="/church-admin/login" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  커뮤니티 관리자
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">고객지원</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/mypage" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  마이페이지
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  공지사항
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  문의하기
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © 2025 WonderM. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              <i className="ri-youtube-fill text-xl"></i>
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
